<div class="card card-long">
	<div class="card-header">
		<ul class="creative-stats">
			<li>
				<span class="stats">{{ creative.impressions | number }}</span>
				<span class="stats-label">Impressions</span>
			</li>
			<li>
				<span class="stats">{{ creative.completions | number }}</span>
				<span class="stats-label">Completions</span>
			</li>
			<li>
				<span class="stats">{{ creative.completionRate }}%</span>
				<span class="stats-label">Completion Rate</span>
			</li>
			<li *ngIf="creative.clicks">
				<span class="stats">{{ creative.clicks | number }}</span>
				<span class="stats-label">Clicks</span>
			</li>
			<li *ngIf="creative.clickRate">
				<span class="stats">{{ creative.clickRate }}%</span>
				<span class="stats-label">Click Rate</span>
			</li>
		</ul>
	</div>
	<div class="card-long-bg">
		<div *ngIf="creative.isAudioCreative" class="audio-container">
			<svg class="audio-svg-icon" viewBox="0 0 218 137" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g transform="translate(0.000000, 0.096846)">
						<circle id="Oval" fill="#ffffff" cx="109" cy="61.9031536" r="61"></circle>
						<path
							d="M19.2716699,-3.55271368e-15 L26.4731158,7.19998973 C16.0640774,22.8719589 10,41.6793857 10,61.9031536 C10,87.505328 19.7183893,110.837651 35.6673835,128.412338 L28.5887441,135.491022 C10.8336612,116.100229 0,90.26686 0,61.9031536 C0,38.9115836 7.11846811,17.582621 19.2716699,-3.55271368e-15 Z M198.72833,0 C210.881532,17.582621 218,38.9115836 218,61.9031536 C218,90.26686 207.166339,116.100229 189.411256,135.491022 L182.332616,128.412338 C198.281611,110.837651 208,87.505328 208,61.9031536 C208,41.6798138 201.936179,22.8727552 191.527545,7.20098512 L198.72833,0 Z M37.3342145,18.0622304 L44.6360574,25.3630257 C38.5030264,36.1428782 35,48.6139281 35,61.9031536 C35,80.6013499 41.9349526,97.6798013 53.3730727,110.706723 L46.289337,117.791583 C33.0475028,102.943816 25,83.3632822 25,61.9031536 C25,45.8369657 29.510474,30.8242555 37.3342145,18.0622304 Z M180.665786,18.0622304 C188.489526,30.8242555 193,45.8369657 193,61.9031536 C193,83.3627989 184.95286,102.942934 171.711558,117.79058 L164.626927,110.706723 C176.065047,97.6798013 183,80.6013499 183,61.9031536 C183,48.6143389 179.49719,36.1436492 173.364511,25.3640253 L180.665786,18.0622304 Z M136.5,25.9031536 L136.5,78.9031536 C136.5,82.7691469 130.903559,85.9031536 124,85.9031536 C117.096441,85.9031536 111.5,82.7691469 111.5,78.9031536 C111.5,75.0371604 117.096441,71.9031536 124,71.9031536 C125.77819,71.9031536 127.469658,72.1110802 129.001105,72.4858852 L129,48.9031536 L94,55.9031536 L94,87.9031536 C94,91.7047137 88.5885528,94.7984834 81.8440688,94.9005531 L81.5,94.9031536 C74.5964406,94.9031536 69,91.7691469 69,87.9031536 C69,84.0371604 74.5964406,80.9031536 81.5,80.9031536 C83.2781895,80.9031536 84.9696579,81.1110802 86.5011052,81.4858852 L86.5,35.9031536 L136.5,25.9031536 Z M129,35.9031536 L94,42.9031536 L94,47.4031536 L129,40.4031536 L129,35.9031536 Z"
							class="secondary-svg-fill"
							fill="#dcdcdc"
							fill-rule="nonzero"
						></path>
					</g>
				</g>
			</svg>
			<audio
				[src]="creative.audioURL"
				controls
				controlsList="nodownload"
				preload="auto"
				class="audioCreativeTag"
			></audio>
		</div>
	</div>
	<div class="card-long-block">
		<div class="card-long-content">
			<div>
				<span class="percent-label">Started</span>
				<span class="percentage">
					<div
						class="percent-bar primary-color-bg"
						appTooltip
						title="Tooltip"
						[title]="creative.videoCompletionPercentage.startedTooltip"
						data-size="big"
						[options]="tooltipOptions"
						[ngStyle]="{ width: creative.videoCompletionPercentage.started + '%' }"
					></div>
				</span>
			</div>
			<div>
				<span class="percent-label">25% Complete</span>
				<span class="percentage">
					<div
						class="percent-bar primary-color-bg"
						appTooltip
						title="Tooltip"
						[title]="creative.videoCompletionPercentage.quarterTooltip"
						data-size="big"
						[options]="tooltipOptions"
						[ngStyle]="{ width: creative.videoCompletionPercentage.quarter + '%' }"
					></div>
				</span>
			</div>
			<div>
				<span class="percent-label">50% Complete</span>
				<span class="percentage">
					<div
						class="percent-bar primary-color-bg"
						appTooltip
						title="Tooltip"
						[title]="creative.videoCompletionPercentage.halfTooltip"
						data-size="big"
						[options]="tooltipOptions"
						[ngStyle]="{ width: creative.videoCompletionPercentage.half + '%' }"
					></div>
				</span>
			</div>
			<div>
				<span class="percent-label">75% Complete</span>
				<span class="percentage">
					<div
						class="percent-bar primary-color-bg"
						appTooltip
						title="Tooltip"
						[title]="creative.videoCompletionPercentage.threeQuartersTooltip"
						data-size="big"
						[options]="tooltipOptions"
						[ngStyle]="{ width: creative.videoCompletionPercentage.threeQuarters + '%' }"
					></div>
				</span>
			</div>
			<div>
				<span class="percent-label">100% Complete</span>
				<span class="percentage">
					<div
						class="percent-bar primary-color-bg"
						appTooltip
						title="Tooltip"
						[title]="creative.videoCompletionPercentage.completedTooltip"
						data-size="big"
						[options]="tooltipOptions"
						[ngStyle]="{ width: creative.videoCompletionPercentage.completed + '%' }"
					></div>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="clear"></div>
